import {Printer, PrinterServerResponse} from 'constants/SampleConstants';
import * as net from 'util/Net';

export function fetchPrinters(): JQueryPromise<{data: Array<Printer>}> {
  return net.getJSON('/1/api/printers');
}

export function createPrinter(data: Omit<Printer, 'id'>): JQueryPromise<PrinterServerResponse> {
  return net.postJSON({url: '/1/api/printers', data});
}

export function updatePrinter(
  printerId: string,
  data: Partial<Printer>
): JQueryPromise<PrinterServerResponse> {
  return net.patchJSON({url: `/1/api/printers/${printerId}`, data});
}

export function deletePrinter(printerId: string): JQueryPromise<{}> {
  return net.delete_({url: `/1/api/printers/${printerId}`});
}
